import { render, staticRenderFns } from "./profile-template-editor.vue?vue&type=template&id=5f67d9b2&scoped=true&"
import script from "./profile-template-editor.vue?vue&type=script&lang=js&"
export * from "./profile-template-editor.vue?vue&type=script&lang=js&"
import style0 from "./profile-template-editor.vue?vue&type=style&index=0&id=5f67d9b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f67d9b2",
  null
  
)

export default component.exports